import { useContext } from 'react';
import { aceIndexKeys } from '../../cache-keys/aceIndexKeys';
import { useQuery } from 'react-query';
import { ace_index_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';

export function useACEIndexOptions() {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const token = ctx?.state?.user?.token ?? '';

  return useQuery({
    queryKey: aceIndexKeys.options(),
    queryFn: () => ace_index_api.options(api)(),
    enabled: token.length > 0,
  });
}
